"use client"

import BackupAllModal from "@/components/backupDomain/BackupAllModal";
import BackupTable from "@/components/backupDomain/BackupTable"
import { getNormalDomains } from "@/services/domains.service";
import { useEffect, useState } from "react";

export interface BackupView {
    ID: string,
    Name: string,
    DBRel: string,
    Website: string,
    Folder: string,
    Package: string,
    BackupAt: string,
    BackingUp: boolean,
}

export default function BackupPage() {
    const [domains, setDomains] = useState<BackupView[]>([]);

    const loadAllDomains = async () => {
        const domains = await getNormalDomains();
        if(domains.length > 0){
            const arr = domains.map(d => {
                return {ID: d.ID, Name: d.Name, DBRel: d.DBRel, Website: d.Website, Folder: d.Folder, Package: d.Package, BackupAt: d.BackupAt, BackingUp: false}
            });
            setDomains(arr);
        } else {
            setDomains([]);
        }
    }

    useEffect(() => {
        loadAllDomains();
    }, [])
    return (
        <div className="flex flex-col gap-6">
            <div>
                <BackupAllModal domains={domains} onBackupSuccess={() => loadAllDomains} onBackupFailed={() => {}} />
            </div>
            <BackupTable domains={domains} />
        </div>
    )
}